import React, { useEffect, useState } from 'react';
import { Instagram, Facebook, Youtube, Send } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/lib/api';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const [email, setEmail] = useState('');
  const [cats, setCats] = useState([]);
  const [rooms, setRooms] = useState([]);
  useEffect(() => {
    api.get('/categories', { params: { type: 'category' } }).then((r) => setCats(r.data || [])).catch(() => {});
    api.get('/categories', { params: { type: 'room' } }).then((r) => setRooms(r.data || [])).catch(() => {});
  }, []);
  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      const { data } = await api.post('/newsletter', { email });
      toast.success(data.message || 'Subscribed!');
      setEmail('');
    } catch { toast.error('Please enter a valid email'); }
  };
  const col = 'space-y-2';
  const link = 'block text-sm text-white/70 transition hover:text-[hsl(var(--gaze-gold))]';
  return (
    <footer className="mt-10 bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))]" data-testid="site-footer">
      <div className="container-gaze grid gap-10 py-14 md:grid-cols-5">
        <div className="md:col-span-2">
          <span className="font-display text-3xl">Gaze Decor</span>
          <p className="mt-3 max-w-xs text-sm text-white/70">The Decor That Speaks: It&apos;s You. Handcrafted luxury decor for the modern Indian home.</p>
          <form onSubmit={subscribe} className="mt-5 flex max-w-sm items-center gap-2 rounded-full border border-white/20 bg-white/5 p-1 pl-4">
            <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="Email for exclusive edits" data-testid="footer-newsletter-input" className="w-full bg-transparent text-sm outline-none placeholder:text-white/50" />
            <button type="submit" data-testid="footer-newsletter-submit" className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-[hsl(var(--gaze-gold))] text-black"><Send size={16} /></button>
          </form>
          <div className="mt-5 flex gap-3">
            <div className="mt-5 flex gap-3">
            <a
              href="https://instagram.com/gazedecor.in"
              target="_blank"
              rel="noreferrer"
              aria-label="Gaze Decor on Instagram"
              className="grid h-9 w-9 place-items-center rounded-full border border-white/20 transition hover:bg-white/10"
            >
              <Instagram size={18} />
            </a>

            <a
              href="https://www.facebook.com/gazedecor.in"
              target="_blank"
              rel="noreferrer"
              aria-label="Gaze Decor on Facebook"
              className="grid h-9 w-9 place-items-center rounded-full border border-white/20 transition hover:bg-white/10"
            >
              <Facebook size={18} />
            </a>

            <a
              href="https://youtube.com/@gazedecor"
              target="_blank"
              rel="noreferrer"
              aria-label="Gaze Decor on YouTube"
              className="grid h-9 w-9 place-items-center rounded-full border border-white/20 transition hover:bg-white/10"
            >
              <Youtube size={18} />
            </a>

            <a
              href="https://www.snapchat.com/add/gazedecor.in"
              target="_blank"
              rel="noreferrer"
              aria-label="Gaze Decor on Snapchat"
              className="grid h-9 w-9 place-items-center rounded-full border border-white/20 transition hover:bg-white/10"
            >
              <span className="text-sm font-bold">👻</span>
            </a>
          </div>
          </div>
        </div>
        <div className={col}>
          <p className="eyebrow mb-3 !text-white/50">Shop</p>
          {cats.slice(0, 6).map((c) => <Link key={c.slug} to={`/category/${c.slug}`} className={link}>{c.name}</Link>)}
        </div>
        <div className={col}>
          <p className="eyebrow mb-3 !text-white/50">Rooms</p>
          {rooms.slice(0, 6).map((r) => <Link key={r.slug} to={`/rooms/${r.slug}`} className={link}>{r.name}</Link>)}
        </div>
        <div className={col}>
          <p className="eyebrow mb-3 !text-white/50">Company</p>
          <Link to="/page/about" className={link}>Our Story</Link>
          <Link to="/blog" className={link}>Journal</Link>
          <Link to="/page/shipping" className={link}>Shipping</Link>
          <Link to="/page/returns" className={link}>Returns</Link>
          <Link to="/contact" className={link}>Contact</Link>
          <Link to="/track" className={link}>Track Order</Link>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-gaze flex flex-col items-center justify-between gap-2 py-5 text-xs text-white/50 sm:flex-row">
          <p>&copy; {new Date().getFullYear()} Gaze Decor. Crafted with intention.</p>
          <div className="flex gap-4">
            <Link to="/page/privacy" className="hover:text-white">Privacy</Link>
            <Link to="/page/terms" className="hover:text-white">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
